import React from 'react';
import { formatDateTime } from '../../utils/dateFormatter';

function ZReportDetail({ report: reportProp, onClose, onDownload }) {
  const report = reportProp.data || reportProp;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS'
    }).format(amount);
  };

  return (
    <>
      <div 
        className="modal-backdrop fade show" 
        style={{ 
          zIndex: 1040,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }}
        onClick={onClose}
      ></div>
      
      <div 
        className="modal fade show" 
        style={{ 
          display: 'block',
          zIndex: 1050,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'auto'
        }} 
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg" style={{ margin: '1.75rem auto' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-receipt me-2"></i>
                Detalles del Reporte Z <strong>N°{report.id}</strong>
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div className="card mb-3">
                    <div className="card-header py-1 mb-2 bg-light">
                      <h6 className="card-title mb-0">
                        <i className="bi bi-info-circle me-2"></i>
                        Información General
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-4">
                          <small className="text-muted">Período: Desde</small>
                          <div className="fw-bold">{formatDateTime(report.period.from)}</div>
                        </div>
                        <div className="col-4">
                          <small className="text-muted">Período: Hasta</small>
                          <div className="fw-bold">{formatDateTime(report.period.to)}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-4">
                          <small className="text-muted">Comercio </small>
                          <div className="fw-bold">{report.channel.name}</div>
                        </div>
                        <div className="col-4">
                          <small className="text-muted">Sucursal:</small>
                          <div className="fw-bold">{report.branch.name}</div>
                        </div>
                        <div className="col-4">
                          <small className="text-muted">Vendedor: </small>
                          <div className="fw-bold">{report.user.name}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-4">
                          <small className="text-muted">Fecha de Creación</small>
                          <div className='fw-bold'>{formatDateTime(report.created_at)}</div>
                        </div>
                        <div className="col-4">
                          <small className="text-muted">Creado por</small>
                          <div className="fw-bold">{report.user_created.name}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="card mb-0">
                    <div className="card-header py-1 mb-3 bg-light">
                      <h6 className="card-title mb-0">
                        <i className="bi bi-calculator me-2"></i>
                        Totales del Período
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: '40%' }}>Concepto</th>
                              <th style={{ width: '30%' }} className='text-center'>Cantidad</th>
                              <th style={{ width: '30%' }} className="text-end">Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="fw-bold">Ventas</td>
                              <td className="text-center">{report.totals.sales_count}</td>
                              <td className="text-end text-success fw-bold">
                                {formatCurrency(report.totals.sold_amount)}
                              </td>
                            </tr>
                            <tr>
                              <td className="fw-bold">Cobros</td>
                              <td className="text-center">{report.totals.payments_count}</td>
                              <td className="text-end text-primary fw-bold">
                                {formatCurrency(report.totals.collected_amount)}
                              </td>
                            </tr>
                            {parseFloat(report.totals.annulments_amount) > 0 && (
                              <tr>
                                <td className="fw-bold">Anulaciones</td>
                                <td className="text-center">{report.totals.annulments_count}</td>
                                <td className="text-end text-danger fw-bold">
                                  {formatCurrency(report.totals.annulments_amount)}
                                </td>
                              </tr>
                            )}
                            <tr className="table-active">
                              <td className="fw-bold">Total</td>
                              <td></td>
                              <td className="text-end text-dark fw-bold">
                                {formatCurrency(report.totals.amount)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {report.observations && (
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header py-1 mb-2 bg-light">
                        <h6 className="card-title mb-0">
                          <i className="bi bi-chat-text me-2"></i>
                          Observaciones
                        </h6>
                      </div>
                      <div className="card-body">
                        <p className="mb-0 px-3">{report.observations}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cerrar
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => onDownload(report.id)}
              >
                <i className="bi bi-download me-2"></i>
                Descargar PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ZReportDetail; 